import PropTypes from 'prop-types'
import styled from 'styled-components'
import Div from 'components/Div'

const flexDirectionValues = ['row', 'row-reverse', 'column', 'column-reverse']
const flexWrapValues = ['nowrap', 'wrap', 'wrap-reverse']
const flexFlowValues = flexDirectionValues
  .map((direction) => flexWrapValues.map((wrap) => `${direction} ${wrap}`))
  .reduce((acc, val) => acc.concat(val), [])

const Flex = styled(Div)`
  display: ${props => props.inline ? 'inline-flex' : 'flex'};
  ${props => props.flexDirection !== undefined ? `flex-direction: ${props.flexDirection};` : ''}
  ${props => props.flexWrap !== undefined ? `flex-wrap: ${props.flexWrap};` : ''}
  ${props => props.flexFlow !== undefined ? `flex-flow: ${props.flexFlow};` : ''}
  ${props => props.justifyContent !== undefined ? `justify-content: ${props.justifyContent};` : ''}
  ${props => props.alignItems !== undefined ? `align-items: ${props.alignItems};` : ''}
  ${props => props.alignContent !== undefined ? `align-content: ${props.alignContent};` : ''}
`
Flex.propTypes = {
  ...Div.propTypes,
  inline: PropTypes.bool,
  flexDirection: PropTypes.oneOf(flexDirectionValues),
  flexWrap: PropTypes.oneOf(flexWrapValues),
  flexFlow: PropTypes.oneOf(flexFlowValues),
  justifyContent: PropTypes.oneOf(['flex-start', 'flex-end', 'center', 'space-between', 'space-around', 'space-evenly']),
  alignItems: PropTypes.oneOf(['flex-start', 'flex-end', 'center', 'baseline', 'stretch']),
  alignContent: PropTypes.oneOf(['flex-start', 'flex-end', 'center', 'space-between', 'space-around', 'stretch'])
}

export default Flex
